import React from 'react';
import { useChatContext } from 'features/message-center/providers';

import { ChatDrawerContent } from './ChatDrawerContent';

export const ChatDrawer = () => {
  const { isDrawerOpen, closeDrawer, recipient, recipientPhoneWithCode } = useChatContext();

  return (
    isDrawerOpen && (
      <ChatDrawerContent
        isDrawerOpen={isDrawerOpen}
        closeDrawer={closeDrawer}
        recipient={recipient}
        recipientPhoneWithCode={recipientPhoneWithCode}
      />
    )
  );
};
